import "./TeamDetails.html";

import "./AddSiteToTeam/AddSiteToTeamComponent";
import "./AddUserToTeam/AddUserToTeamComponent";
import "./EditTeamMember/EditTeamMemberComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TeamDetailsComponentController from "./TeamDetailsComponentController";

export default class TeamDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            teamId: "<",
        };
        this.controller = TeamDetailsComponentController;
        this.templateUrl = "/App/Components/Team/TeamDetails.html";
    }
}

module("mmManagePortal").component("mmTeamDetails", new TeamDetailsComponent());
